import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import React from 'react';
import { SafeAnchor } from '../SafeAnchor';
import { Dropdown } from './';
export const NavDropdown = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { id, title, children, className, rootCloseEvent, menuRole, disabled, active, renderMenuOnMount, ...rest } = props;
    return /*#__PURE__*/ _jsxs(Dropdown, {
        ref: ref,
        ...rest,
        className: classNames(className, 'nav-item'),
        children: [
            /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                id: id,
                active: active,
                disabled: disabled,
                componentClass: SafeAnchor,
                className: "nav-link",
                children: title
            }),
            /*#__PURE__*/ _jsx(Dropdown.Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                children: children
            })
        ]
    });
});
NavDropdown.displayName = 'NavDropdown';
